export default __webpack_public_path__ + "static/media/Standard14.7c621bcc.png";